import { Label } from './label';
import { ICategory, OwnerByEnum } from './model';

export class Category implements ICategory {
	ID: string;
	Name: string;
	OwnerBy: OwnerByEnum;
	Owner: string;
	Position: number;
	Labels: Label[];
	public static fromInterface(data: ICategory) {
		const rev = new Category();
		rev.ID = data.ID;
		rev.Name = data.Name;
		rev.OwnerBy = data.OwnerBy;
		rev.Owner = data.Owner;
		rev.Position = data.Position;
		if (data.Labels) {
			rev.Labels = data.Labels.map(v => Label.fromInterface({ CategoryID: data.ID, ...v }));
		}
		return rev;
	}
	displayLabel(): string {
		return `${this.Position}.${this.Name}(${this.Owner})`;
	}
	setLabelsPosition(ids: string[]) {
		const oldArray = [...this.Labels];
		this.Labels.splice(0, oldArray.length, ...ids.map(v => oldArray.find(vv => vv.ID === v)));
	}
}
